document.addEventListener("DOMContentLoaded", () => {
  const counters = document.querySelectorAll('.counter');
  const speed = 200; // adjust speed

  const animateCounter = (counter) => {
    const target = +counter.getAttribute('data-target');
    let count = 0;
    const increment = target / speed;

    const updateCount = () => {
      if (count < target) {
        count += increment;
        counter.innerText = Math.ceil(count);
        requestAnimationFrame(updateCount);
      } else {
        counter.innerText = target.toLocaleString(); // adds commas
      }
    };

    updateCount();
  };

  // Use IntersectionObserver so counters animate only once when visible
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target); // stop re-triggering
        }
      });
    },
    { threshold: 0.3 } // trigger when 30% visible
  );

  counters.forEach(counter => {
    observer.observe(counter);
  });
});
